<ng-template #authButtonsMenu>
  <div
    class="tw-px-5 tw-pt-[15px] tw-pb-[5px] tw-flex tw-items-center tw-gap-2.5"
  >
    @if (userPicture) {
      <img
        [src]="userPicture"
        class="profile-pic"
        width="40"
        height="40"
        alt="User"
      />
    } @else {
      <initials-badge [name]="userFullName" [size]="40"></initials-badge>
    }
    <div>
      <div class="tw-font-bold tw-text-gray-700">{{ userFullName }}</div>
      <div class="tw-text-[13px] tw-text-gray-500">{{ username }}</div>
    </div>
  </div>

  <div class="separator"></div>
  <mat-nav-list
    id="authButtonsMenu"
    class="tw-px-[5px]"
    role="menu"
    aria-label="User menu"
    aria-orientation="vertical"
    (keydown)="onMenuKeydown($event)"
  >
    @if (!isScreenShareApp) {
      <a
        mat-list-item
        uiSref="apps.user.details"
        [uiParams]="{ username: '' }"
        class="user-settings-button action"
        tabindex="0"
        aria-label="My Profile"
        role="menuitem"
      >
        <div class="tw-flex tw-items-center tw-gap-2.5">
          <mat-icon svgIcon="user-circle" class="small thin"></mat-icon>
          <span class="item-name">My Profile</span>
        </div>
      </a>
    } @else {
      <a
        mat-list-item
        href="https://help.risevision.com/hc/en-us/articles/29009023259156-How-do-I-Set-Up-Screen-Sharing-on-a-display-in-Rise-Vision-Coming-Soon"
        target="_blank"
        rel="noopener noreferrer"
        class="action"
        tabindex="-1"
        aria-label="Help"
        role="menuitem"
      >
        <div class="tw-flex tw-items-center tw-gap-2.5">
          <mat-icon svgIcon="help" class="small"></mat-icon>
          <span class="item-name">Help</span>
        </div>
      </a>
    }
    <a
      mat-list-item
      uiSref="apps.sitemap.home"
      class="action"
      tabindex="-1"
      aria-label="Sitemap"
      role="menuitem"
    >
      <div class="tw-flex tw-items-center tw-gap-2.5">
        <mat-icon svgIcon="dataflow-01" class="small"></mat-icon>
        <span class="item-name">Sitemap</span>
      </div>
    </a>
    <a
      mat-list-item
      href="https://help.risevision.com/hc/en-us/articles/360000924446-Terms-of-Service"
      target="_blank"
      rel="noopener noreferrer"
      class="action"
      tabindex="-1"
      aria-label="Software Terms of Service"
      role="menuitem"
    >
      <div class="tw-flex tw-items-center tw-gap-2.5">
        <mat-icon svgIcon="file" class="small medium"></mat-icon>
        <span class="item-name">Software Terms of Service</span>
      </div>
    </a>
    <button
      type="button"
      mat-list-item
      class="action sign-out-button"
      signOutButton
      tabindex="-1"
      aria-label="Sign out"
      role="menuitem"
    >
      <div class="tw-flex tw-items-center tw-gap-2.5">
        <mat-icon svgIcon="sign-out" class="small medium"></mat-icon>
        <span class="item-name">Sign Out</span>
      </div>
    </button>
  </mat-nav-list>
</ng-template>

<!-- Desktop and tablet -->
<div class="dropdown user-profile-dropdown desktop-menu-item hidden-xs">
  <button
    mat-icon-button
    type="button"
    [matMenuTriggerFor]="menuAuthButtons"
    (menuOpened)="onMenuOpened()"
    class="dropdown-toggle hover:tw-bg-brand-bg"
    aria-label="User Menu"
    tabindex="0"
  >
    <ng-container *ngTemplateOutlet="profilePicture"></ng-container>
  </button>
  <mat-menu #menuAuthButtons="matMenu" class="auth-buttons-menu">
    <ng-template matMenuContent>
      <ng-container *ngTemplateOutlet="authButtonsMenu"></ng-container>
    </ng-template>
  </mat-menu>
</div>

<!-- Mobile -->
<div
  class="dropdown user-profile-dropdown mobile-menu-item visible-xs-inline-block"
>
  <span id="modal-label" class="cdk-visually-hidden">User Menu</span>
  <button
    mat-icon-button
    type="button"
    class="visible-xs dropdown-toggle"
    (click)="openMobileMenu(authButtonsMenu)"
    aria-label="User Menu"
    tabindex="0"
  >
    <ng-container *ngTemplateOutlet="profilePicture"></ng-container>
  </button>
</div>

<ng-template #profilePicture>
  @if (userPicture) {
    <img
      [src]="userPicture"
      class="profile-pic"
      width="32"
      height="32"
      alt="User"
    />
  } @else {
    <initials-badge
      class="profile-pic"
      [name]="userFullName"
      [size]="32"
    ></initials-badge>
  }
</ng-template>
